{
  "nodes": [
    {
      "id": "854231",
      "code": 854231,
      "name": "Electronic integrated circuits",
      "level": 0
    },
    {
      "id": "854221",
      "code": 854221,
      "name": "Monolithic integrated circuits, digital",
      "level": 1
    },
    {
      "id": "854229",
      "code": 854229,
      "name": "Electronic integrated circuits, monolithic",
      "level": 1
    },
    {
      "id": "854260",
      "code": 854260,
      "name": "Hybrid integrated circuits",
      "level": 1
    },
    {
      "id": "854890",
      "code": 854890,
      "name": "Electrical parts of machinery or apparatus, nes",
      "level": 1
    },
    {
      "id": "854213",
      "code": 854213,
      "name": "Metal oxide semiconductors",
      "level": 2
    },
    {
      "id": "854214",
      "code": 854214,
      "name": "Circuits obtained by bipolar technology",
      "level": 2
    },
    {
      "id": "854219",
      "code": 854219,
      "name": " Integrated circuits, monolitihic non-digital",
      "level": 2
    },
    {
      "id": "854230",
      "code": 854230,
      "name": "Other monolithic integrated circuits",
      "level": 2
    },
    {
      "id": "854240",
      "code": 854240,
      "name": "Hybrid integrated circuits",
      "level": 2
    },
    {
      "id": "854890_2",
      "code": 854890,
      "name": "Electrical parts of machinery or apparatus, nes",
      "level": 2
    },
    {
      "id": "854211",
      "code": 854211,
      "name": "Monolithic integrated circuits, digital",
      "level": 3
    },
    {
      "id": "854219_2",
      "code": 854219,
      "name": "Monolithic integrated circuits, except digital",
      "level": 3
    },
    {
      "id": "854220",
      "code": 854220,
      "name": "Hybrid integrated circuits",
      "level": 3
    },
    {
      "id": "854800",
      "code": 854800,
      "name": "Electrical parts of machinery and apparatus, nes",
      "level": 3
    }
  ],
  "links": [
    { "source": "854231", "target": "854221", "level": 1, "step": "" },
    { "source": "854231", "target": "854229", "level": 1, "step": "UN" },
    { "source": "854231", "target": "854260", "level": 1, "step": "" },
    { "source": "854231", "target": "854890", "level": 1, "step": "" },
    { "source": "854221", "target": "854213", "level": 2, "step": "" },
    { "source": "854221", "target": "854214", "level": 2, "step": "" },
    { "source": "854221", "target": "854219", "level": 2, "step": "" },
    { "source": "854229", "target": "854230", "level": 2, "step": "UN" },
    { "source": "854260", "target": "854240", "level": 2, "step": "" },
    { "source": "854890", "target": "854890_2", "level": 2, "step": "" },
    { "source": "854213", "target": "854211", "level": 3, "step": "" },
    { "source": "854214", "target": "854211", "level": 3, "step": "" },
    { "source": "854219", "target": "854211", "level": 3, "step": "" },
    { "source": "854219", "target": "854219_2", "level": 3, "step": "" },
    { "source": "854230", "target": "854219_2", "level": 3, "step": "UN" },
    { "source": "854240", "target": "854220", "level": 3, "step": "" },
    { "source": "854890_2", "target": "854800", "level": 3, "step": "" }
  ]
}
